// URL công khai của 1 landing page trên web (dùng để xem thử + dán vào Tiện ích App).
const FRONTEND_URL = (process.env.REACT_APP_FRONTEND_URL || "").replace(/\/$/, "");

export function landingPageUrl(slug) {
    return `${FRONTEND_URL}/trang/${slug}`;
}

/** Chuẩn hoá slug giống backend: bỏ dấu, hạ chữ thường, ký tự lạ -> '-'. */
export function toSlug(input) {
    return String(input || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[đĐ]/g, "d")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, 160);
}
